import { gql, useQuery } from '@apollo/client';

const PREVIEW_FILE = gql`
  query Query($id: String!, $token: String) {
    getFilePreview(id: $id, token: $token)
  }
`;

export interface FilePreviewInput {
  id: string;
  token?: string;
  skip?: boolean;
}

export interface FilePreviewResult {
  getFilePreview: string[];
}

export function useFilePreviewQuery({ skip, ...input }: FilePreviewInput) {
  return useQuery<FilePreviewResult, Omit<FilePreviewInput, 'skip'>>(PREVIEW_FILE, {
    variables: input,
    skip,
  });
}
